// Mesmas fórmulas da "Calculadora de Amortização" do Multi Tech
// (e do helper do backend que a IA usa: helpers/CalculadoraAmortizacao.ts).

export const arredondar = (v) => Math.round(v * 100) / 100;

export const moeda = (v) =>
  "R$ " +
  (Number.isFinite(v) ? v : 0).toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

/** "1.234,56" -> 1234.56 */
export const lerNumero = (texto) => {
  let s = String(texto ?? "").replace(/[^\d,.-]/g, "");
  if (!s) return 0;
  if (s.includes(",")) s = s.replace(/\./g, "").replace(",", ".");
  const n = parseFloat(s);
  return Number.isFinite(n) ? n : 0;
};

/** Máscara de dinheiro: digita só números, sai "40.000,00". */
export const mascaraDinheiro = (texto) => {
  const digitos = String(texto || "").replace(/\D/g, "");
  if (!digitos) return "";
  const v = (parseInt(digitos, 10) / 100).toFixed(2).replace(".", ",");
  return v.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
};

export const taxaMensalEfetiva = (taxaPct, tipo) => {
  const t = Math.max(0, lerNumero(taxaPct)) / 100;
  return tipo === "anual" ? Math.pow(1 + t, 1 / 12) - 1 : t;
};

/** Gera a tabela completa e o resumo. */
export const calcularTabela = ({ valor, parcelas, taxa, sistema }) => {
  const n = parseInt(parcelas, 10) || 0;
  if (!(valor > 0) || n <= 0) return null;

  let pmt = 0;
  let parcelaFixa = 0;
  let amortConst = 0;
  if (sistema === "price") {
    if (taxa > 0) {
      const f = Math.pow(1 + taxa, n);
      pmt = valor * ((taxa * f) / (f - 1));
    } else {
      pmt = valor / n;
    }
    parcelaFixa = arredondar(pmt);
  } else {
    amortConst = valor / n;
  }

  let saldo = valor;
  let totalJuros = 0;
  let totalPagar = 0;
  const linhas = [];

  for (let i = 1; i <= n; i++) {
    const jurosCalc = saldo * taxa;
    const juros = arredondar(jurosCalc);
    let amort;
    let parcela;
    if (sistema === "price") {
      amort = arredondar(pmt - jurosCalc);
      parcela = parcelaFixa;
    } else {
      amort = arredondar(amortConst);
      parcela = arredondar(jurosCalc + amortConst);
    }
    if (i === n) {
      amort = saldo;
      parcela = arredondar(juros + amort);
    }
    const anterior = saldo;
    saldo = arredondar(saldo - amort);
    totalJuros += juros;
    totalPagar += parcela;
    linhas.push({ n: i, parcela, amort, juros, anterior, saldo: Math.max(0, saldo) });
  }

  return {
    linhas,
    primeira: linhas[0].parcela,
    ultima: linhas[n - 1].parcela,
    totalJuros: arredondar(totalJuros),
    totalPagar: arredondar(totalPagar),
  };
};

/** Rótulo do vencimento da parcela i a partir de "AAAA-MM". */
export const vencimento = (inicio, i) => {
  if (!inicio || !/^\d{4}-\d{2}$/.test(inicio)) return `${i}º mês`;
  const [a, m] = inicio.split("-").map(Number);
  const d = new Date(a, m - 1 + (i - 1), 1);
  return d.toLocaleDateString("pt-BR", { month: "short", year: "numeric" }).replace(".", "");
};
